export interface DSTabDefinition {
  id: string;
  label: string;
}

export const DS_TABS: DSTabDefinition[] = [
  { id: 'colors', label: 'Couleurs' },
  { id: 'typography', label: 'Typographie' },
  { id: 'buttons', label: 'Boutons' },
  { id: 'badges', label: 'Badges' },
  { id: 'cards', label: 'Cards' },
  { id: 'forms', label: 'Formulaires' },
  { id: 'feedback', label: 'Feedback' },
  { id: 'avatars', label: 'Avatars & Spinners' },
  { id: 'overlays', label: 'Overlays' },
  { id: 'data', label: 'Tables' },
  { id: 'domain', label: 'Domaine métier' },
  { id: 'timeline', label: 'Timeline' },
  { id: 'shadcn', label: 'shadcn/ui' },
];
